import { Globals } from "../../globals/variables";
import { getAnalitycStorage } from "../../utils/analytics";
import { getSearchParamValueUrl } from "../../utils/utils";
import { getCodProvincia, getEntorno } from "../Tracking/ringpool";

function loadLib(url, idTag) {
  return new Promise((resolve, reject) => {
    globalThis.idTagDelio = idTag;
    const script = globalThis.document.createElement("script");
    script.src = url;
    script.id = "initWalmeric";
    script.async = true;
    script.onload = () => {
      resolve(); // Carga
    };
    script.onerror = reject; // No carga
    document.head.appendChild(script);
  });
}

function loadgbraid(){
  let url = window.location.href;
  let newUrl = new URL(url);
  let paramGbraid = newUrl.searchParams.get("gbraid")
  paramGbraid != "" ? dataLayerMovistarProsegur.gbraid = paramGbraid : null;
}

export const loadD1C = async () => {
  globalThis.idTagDelio = Globals.idTagD1C;

  if (typeof dataLayerMovistarProsegur != "object") {
    window.dataLayerMovistarProsegur = {};
  }

  dataLayerMovistarProsegur.Entorno = getEntorno();
  dataLayerMovistarProsegur.Cod_Procedencia = await getCodProvincia(
    "utm_source"
  );
  dataLayerMovistarProsegur.utm_brand = await getSearchParamValueUrl(
    "utm_brand"
  );
  dataLayerMovistarProsegur.utm_product = await getSearchParamValueUrl(
    "utm_product"
  );
  dataLayerMovistarProsegur.utm_target = await getSearchParamValueUrl(
    "utm_target"
  );

  loadgbraid()

  loadLib(
    "https://t.womtp.com/slider/c/delio-lm/dfi/init.js",
    Globals.idTagD1C
  );
};
